var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabbed-page-layout',{staticClass:"fraud",attrs:{"title":"Bedrageri","pages":_vm.pages}},[_vm._t("tools",null,{"slot":"tools"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }